export const AM_CHARTS_LICENCE = "CH225886773";
